// Klaviyo Back-in-Stock Integration
// Handles notify me form submissions to Klaviyo

(function () {
  "use strict";

  const COMPANY_ID = "RU2ww8";
  const REVISION = "2025-07-15";
  const EMAIL_MARKETING_LIST_ID = "UwUC7Z";

  // Flag to ensure script only runs once
  let isInitialized = false;

  function initializeKlaviyoIntegration() {
    if (isInitialized) return;
    isInitialized = true;

    // Use event delegation to handle dynamically added notify me buttons
    document.addEventListener("click", function (e) {
      const notifyBtn = e.target.closest(".notify-me-btn");
      if (!notifyBtn) return;

      const formContainer = notifyBtn.closest(".back-in-stock-form");
      if (!formContainer) return;

      // Get region-with-sku from the container (already formatted in out-of-stock.liquid)
      const regionWithSku = formContainer.getAttribute("region-with-sku");

      if (!regionWithSku) {
        console.error("No region-with-sku found in back-in-stock form");
        return;
      }

      const emailInput =
        formContainer.querySelector("input[type='email']") || formContainer.querySelector("#back-in-stock-email");
      if (!emailInput) {
        return;
      }

      const email = emailInput.value.trim();
      if (!email) {
        showMessage(formContainer, "Please enter your email", "error");
        emailInput.focus();
        return;
      }

      // Validate email format
      const emailRegex = /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;
      if (!emailRegex.test(email)) {
        showMessage(formContainer, "Please enter a valid email", "error");
        emailInput.focus();
        return;
      }

      sendBIS(email, regionWithSku, notifyBtn);
    });
  }

  function subscribeToEmailMarketing(email) {
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED",
                    },
                  },
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: EMAIL_MARKETING_LIST_ID,
            },
          },
        },
      },
    };

    const url = new URL("https://a.klaviyo.com/client/subscriptions/");
    url.searchParams.set("company_id", COMPANY_ID);

    return fetch(url.toString(), {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        "content-type": "application/vnd.api+json",
        revision: REVISION,
      },
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(`Marketing subscription failed (${response.status})`);
      }
    });
  }

  function sendBIS(email, regionWithSku, button) {
    const formContainer = button?.closest(".back-in-stock-form");

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: { type: "profile", attributes: { email } },
          },
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$custom:::$default:::${regionWithSku}`,
            },
          },
        },
      },
    };

    const url = new URL("https://a.klaviyo.com/client/back-in-stock-subscriptions");
    url.searchParams.set("company_id", COMPANY_ID);

    subscribeToEmailMarketing(email)
      .catch((error) => {
        console.warn("Klaviyo marketing subscription request failed before BIS submit.", error);
      })
      .then(() => {
        fetch(url.toString(), {
          method: "POST",
          headers: {
            accept: "application/vnd.api+json",
            "content-type": "application/vnd.api+json",
            revision: REVISION,
          },
          body: JSON.stringify(payload),
        })
          .then((response) => {
            if (response.ok) {
              showSuccessMessage(button);
            } else {
              showMessage(formContainer, "Subscription failed. Please try again.", "error");
            }
          })
          .catch(() => {
            showMessage(formContainer, "Network error. Please check your connection and try again.", "error");
          });
      });
  }

  function showSuccessMessage(button) {
    const formContainer = button.closest(".back-in-stock-form");
    showMessage(formContainer, "Thanks, love! We'll send you an email as soon as it's back in stock.", "success");

    const form = formContainer.querySelector("form");
    form?.reset();

    const originalText = button.textContent;
    button.textContent = "Subscribed!";
    button.disabled = true;
    button.style.opacity = "0.7";

    // Reset after 3 seconds
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
      button.style.opacity = "1";
    }, 1000);
  }

  function showMessage(formContainer, message, type) {
    // Find the message div
    const messageDiv = formContainer.parentNode.querySelector(".back-in-stock-message");
    if (!messageDiv) {
      return;
    }

    // Clear any existing content
    messageDiv.innerHTML = "";
    messageDiv.className = "back-in-stock-message";

    // Set message content
    messageDiv.textContent = message;

    // Apply styling based on type
    if (type === "error") {
      messageDiv.style.color = "#c00";
      messageDiv.classList.add("error-message");
    } else if (type === "success") {
      messageDiv.style.color = "#000";
      messageDiv.style.fontWeight = "bold";
      messageDiv.classList.add("success-message");
    }

    // Common styling
    messageDiv.style.fontSize = "13px";
    messageDiv.style.padding = "8px";
    messageDiv.style.display = "block";
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeKlaviyoIntegration);
  } else {
    initializeKlaviyoIntegration();
  }
})();
